import { render, staticRenderFns } from "./EventReportTable.vue?vue&type=template&id=66ee9650"
import script from "./EventReportTable.vue?vue&type=script&lang=js"
export * from "./EventReportTable.vue?vue&type=script&lang=js"
import style0 from "./EventReportTable.vue?vue&type=style&index=0&id=66ee9650&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports